import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import PasswordGate from "./components/PasswordGate";
import LandingPage from "./pages/LandingPage";
import AdminDashboard from "./pages/AdminDashboard";
import UserManagement from "./pages/UserManagement";
import UserProfile from "./pages/UserProfile";
import StorageConfig from "./pages/StorageConfig";
import Reports from "./pages/Reports";
import Leaderboard from "./pages/Leaderboard";
import UserDashboard from "./pages/UserDashboard";
import CreateSession from "./pages/CreateSession";
import LiveSession from "./pages/LiveSession";
import SessionFeedback from "./pages/SessionFeedback";
import SessionReplay from "./pages/SessionReplay";
import Compliance from "./pages/Compliance";
import DepartmentProfile from "./pages/DepartmentProfile";
import UserPortal from "./pages/UserPortal";
import UserCreateSession from "./pages/UserCreateSession";
import ActivityLog from "./pages/ActivityLog";
import SystemStatus from "./pages/SystemStatus";
import PresentationLibrary from "./pages/PresentationLibrary";
import AdminLibrary from "./pages/AdminLibrary";
import LibraryDetail from "./pages/LibraryDetail";
import UserLibrary from "./pages/UserLibrary";
import UserLibraryDetail from "./pages/UserLibraryDetail";
import Documentation from "./pages/Documentation";
import MasterDelete from "./pages/MasterDelete";
import ConversionSettings from "./pages/ConversionSettings";
import LLMSettings from "./pages/LLMSettings";
import OneDriveSettings from "./pages/OneDriveSettings";
import "./App.css";

// Admin Layout with Password Protection
function AdminLayout() {
  return (
    <PasswordGate type="admin">
      <Layout />
    </PasswordGate>
  );
}

// User Dashboard Layout with Password Protection
function UserDashboardLayout() {
  return (
    <PasswordGate type="user">
      <Layout />
    </PasswordGate>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        
        {/* User Portal Routes (via share link) - NO password needed (shareable links) */}
        <Route path="/u/:token" element={<UserPortal />} />
        <Route path="/u/:token/session/new" element={<UserCreateSession />} />
        <Route path="/u/:token/library" element={<UserLibrary />} />
        <Route path="/u/:token/library/:id" element={<UserLibraryDetail />} />
        
        {/* Admin Routes - Password Protected */}
        <Route element={<AdminLayout />}>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/users" element={<UserManagement />} />
          <Route path="/admin/users/:userId" element={<UserProfile />} />
          <Route path="/admin/storage" element={<StorageConfig />} />
          <Route path="/admin/conversion" element={<ConversionSettings />} />
          <Route path="/admin/llm" element={<LLMSettings />} />
          <Route path="/admin/onedrive" element={<OneDriveSettings />} />
          <Route path="/admin/reports" element={<Reports />} />
          <Route path="/admin/compliance" element={<Compliance />} />
          <Route path="/admin/activity" element={<ActivityLog />} />
          <Route path="/admin/system" element={<SystemStatus />} />
          <Route path="/admin/library" element={<AdminLibrary />} />
          <Route path="/admin/library/:id" element={<LibraryDetail />} />
          <Route path="/admin/docs" element={<Documentation />} />
          <Route path="/admin/master-delete" element={<MasterDelete />} />
          <Route path="/admin/department/:department" element={<DepartmentProfile />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
        </Route>
        
        {/* User Dashboard Routes - Password Protected */}
        <Route element={<UserDashboardLayout />}>
          <Route path="/dashboard" element={<UserDashboard />} />
          <Route path="/session/new" element={<CreateSession />} />
          <Route path="/session/:id/feedback" element={<SessionFeedback />} />
          <Route path="/session/:id/replay" element={<SessionReplay />} />
          <Route path="/library" element={<PresentationLibrary />} />
          <Route path="/library/:id" element={<LibraryDetail />} />
        </Route>
        
        {/* Live Session - No password (accessed from shareable link) */}
        <Route path="/session/:id/live" element={<LiveSession />} />
      </Routes>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
